const formattedPrice = (price, onlyFloat = true) => {
  price = parseFloat(price);

  if (onlyFloat || !Number.isInteger(price))
    return price.toFixed(2);

  return price;
};

export default formattedPrice;
